import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import users from "./modules/users";
import servers from "./modules/servers";
import clients from "./modules/clients";

export default new Vuex.Store({
  state: {
    isDetail: false,
    showBottom: true,
    showAdd: true,
    menus: [
      {
        path: "/microservices",
        name: "Microservicios",
        icon: "memory"
      },
      {
        path: "/servers",
        name: "Servidores",
        icon: "storage"
      },
      {
        path: "/clients",
        name: "Clientes",
        icon: "person_pin"
      }
    ],
    ftbOptions: [
      {
        icon: "memory",
        name: "cliente",
        path: "/client"
      },
      {
        icon: "storage",
        name: "servidor",
        path: "/server"
      }
    ]
  },
  modules: {
    users,
    servers,
    clients,
    addItem: () => {}
  },
  mutations: {
    isDetail(state) {
      state.isDetail = true;
    },
    toggleAdd(state, payload) {
      state.showAdd = payload;
    },
    toogleBottom(state, payload) {
      state.showBottom = payload;
    },
    notDetail(state) {
      state.isDetail = false;
    }
  },
  actions: {},
  getters: {
    menus: state => state.menus,
    ftbOptions: state => state.ftbOptions,
    isDetail: state => state.isDetail,
    showAdd: state => state.showAdd,
    showBottom: state => state.showBottom
  }
});
